import { render, staticRenderFns } from "./sidebarItem.vue?vue&type=template&id=449c0504&"
import script from "./sidebarItem.vue?vue&type=script&lang=ts&"
export * from "./sidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./sidebarItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports